export default __webpack_public_path__ + "static/media/Hiawatha art logo2.e3faf0b7.png";